import type { PartialTheme } from "@fluentui/theme";
import store from "../store/store";

export default function getDensity(): PartialTheme | undefined {
    return store().density;
}
